import { useState } from 'react';

import { WidgetViewMode } from 'utilitys/reporting/widgetViewModeUtils';

import { useQueryAssigneeList } from 'api/queries/assigneeList.query';

interface Props {
    componentKey: string;
    widgetId?: string;
    localFilters: any;
    widgetViewMode?: WidgetViewMode;
}

export const useCustomReportTextProvider = ({ localFilters }: Props) => {
    const [description, setDescription] = useState<string>(() => {
        return localFilters ? localFilters.description : '';
    });
    const assigneeList = useQueryAssigneeList();
    return {
        ui: {
            state: {
                description,
            },
            setters: {
                setDescription,
            },
        },
        api: {
            assigneeList,
        },
    };
};
